<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="marketTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo do Ativo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.marketTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Corrente</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioClearingAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Conta CETIP, SELIC ou B3
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioClearingAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="amount">
    <th mat-header-cell class="header" *matHeaderCellDef>Quantidade</th>
    <td mat-cell *matCellDef="let element">
      {{ element.amount | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="unitPrice">
    <th mat-header-cell class="header" *matHeaderCellDef>Preço Unitário</th>
    <td mat-cell *matCellDef="let element">
      {{ element.unitPrice | currency: "R$":"symbol":"1.8-8" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationValue">
    <th mat-header-cell class="header" *matHeaderCellDef>Valor da Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationValue | currency: "R$":"symbol":"1.8-8" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="hasSameOwnership">
    <th mat-header-cell class="header" *matHeaderCellDef>Mesma Titularidade</th>
    <td mat-cell *matCellDef="let element">
      {{ element.hasSameOwnership ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="securityType">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Nome Ativo ou Título
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.securityType }}
    </td>
  </ng-container>

  <ng-container matColumnDef="securityCode">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Código Ativo ou Título
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.securityCode }}
    </td>
  </ng-container>

  <ng-container matColumnDef="expirationDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data Vencimento</th>
    <td mat-cell *matCellDef="let element">
      {{ element.expirationDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="purchaseDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data de Aquisição</th>
    <td mat-cell *matCellDef="let element">
      {{ element.purchaseDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="issuer">
    <th mat-header-cell class="header" *matHeaderCellDef>Emissor</th>
    <td mat-cell *matCellDef="let element">
      {{ element.issuer }}
    </td>
  </ng-container>

  <ng-container matColumnDef="command">
    <th mat-header-cell class="header" *matHeaderCellDef>Comando</th>
    <td mat-cell *matCellDef="let element">
      {{ element.command }}
    </td>
  </ng-container>

  <ng-container matColumnDef="asset">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do papel</th>
    <td mat-cell *matCellDef="let element">
      {{ element.asset }}
    </td>
  </ng-container>

  <ng-container matColumnDef="quotation">
    <th mat-header-cell class="header" *matHeaderCellDef>Cotação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.quotation }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isNewCounterpart">
    <th mat-header-cell class="header" *matHeaderCellDef>
      É Nova Contraparte?
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.isNewCounterpart ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>Cnpj Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartClearingAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Conta CETIP, SELIC ou B3 Contraparte
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartClearingAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartBrokerAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Conta Broker Contraparte
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartBrokerAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.bank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.branch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta</th>
    <td mat-cell *matCellDef="let element">
      {{ element.account }}
    </td>
  </ng-container>

  <ng-container matColumnDef="annotations">
    <th mat-header-cell class="header" *matHeaderCellDef>Observação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.annotations }}
    </td>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="ColumnsMargin.length"
    >
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <h4>Erros encontrados:</h4>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsMargin"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsMargin"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
